import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import Link from "@mui/material/Link";
import PageTest from "./pageTest";
import Reference from "./Reference";
import { Link as RLink } from "react-router-dom";

export default function NotConnectedPage() {
    return (
        <Container>
            <br />
            <Card sx={{ minWidth: 300, align: "center" }}>
                <CardMedia
                    component="img"
                    height="294"
                    image="/protostructure.202410111749.png"
                    alt="Protos"
                />
                <CardContent>
                    Welcome to <b>Protostructure</b>
                    Your one-stop solution for <b>Documentation</b>,
                    <b>Software Design</b>, <b>Project Management</b>, and
                    <b>Ticketing services</b>. Our platform is here to help you
                    stay organized and efficient.
                </CardContent>
            </Card>

            <Card sx={{ minWidth: 300, align: "center" }}>
                <CardContent>
                    <Typography sx={{ color: "text.secondary" }}>
                        What You Can Do
                    </Typography>
                    <br />
                    <Typography variant="h5">Documentation</Typography>
                    <br />
                    Accurate, structured, and up-to-date documentation is key to
                    any successful project. Create and maintain clear, detailed,
                    and accessible documentation in one central location. From
                    technical manuals to project roadmaps, our platform makes it
                    easy to capture, edit, and share vital information with your
                    team or clients.
                    <br />
                    <br />
                    <Typography variant="h5">Software Design</Typography>
                    <br />
                    Use our flexible design tools to plan and document your
                    software projects. From wireframes and workflows to system
                    architecture, you can easily build and manage the structure
                    of your software right within the platform.
                    <br />
                    <br />
                    <Typography variant="h5">Project Management</Typography>
                    <br />
                    Manage your projects with ease using our intuitive project
                    management features. Set goals, track progress, assign
                    tasks, and stay on top of every phase of your
                    project—ensuring everything stays on schedule.
                    <br />
                    <br />
                    <Typography variant="h5">Ticketing & Support</Typography>
                    <br />
                    Ensure smooth operations with our integrated ticketing
                    system. We provide tools for tracking, managing, and
                    resolving issues effectively. Our support system ensures
                    your team can stay focused while we handle the technical
                    challenges.
                    <br />
                    <br />
                    <Typography variant="h5">Collaboration</Typography>
                    <br />
                    Protostructure enhances collaboration by allowing teams to
                    work together in real-time. Share updates, assign tasks,
                    comment on projects, and keep everyone on the same page.
                </CardContent>
            </Card>
            <Card sx={{ minWidth: 400, align: "center" }}>
                <CardContent>
                    <Typography sx={{ color: "text.secondary" }}>
                        Why Protostructure?
                    </Typography>
                    <br />
                    <br />
                    All-in-One Platform: Everything you need for project
                    management, documentation, software design, and ticketing in
                    one place.
                    <br />
                    <br />
                    Effortless Organization: Keep all your files, projects, and
                    communications organized and accessible from anywhere.
                    <br />
                    <br />
                    Streamlined Workflow: Simplify your processes and improve
                    productivity with an intuitive, user-friendly interface.
                    <br />
                    <br />
                </CardContent>
            </Card>
        </Container>
    );
}
